import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const HorizontalTemplateOneOneEight = ({
  backgroundType = "image",
  backgroundColor = null,
  backgroundImage = "/singleBgHorizontal.png",

  buttonLabel = "Register Now",
  buttonFont = "Helvetica",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "18",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#32CD32",

  backgroundImagePreview,

  inmeeting = false,
  position = null,
  preview = false,
  onClose,
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  const defaultBackgroundImage = "/singleBgHorizontal.png";
  const finalBackgroundImage =
    backgroundImage || backgroundImagePreview || defaultBackgroundImage;

  return (
    <div
      className={`relative ${
        !inmeeting
          ? "h-auto"
          : ["top", "bottom"].includes(position)
          ? "h-[150px]"
          : "!h-[89vh] mt-[5%]"
      } w-full flex flex-row mx-auto items-center px-4 md:px-8 py-3 md:py-4 overflow-hidden`}
      style={{
        backgroundImage: `url(${
          finalBackgroundImage instanceof File
            ? backgroundImagePreview
            : finalBackgroundImage
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: backgroundColor, // Fallback if image fails
      }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Content Container */}
      <div className="relative z-10 flex items-center justify-end w-full max-w-7xl mx-auto">
        {/* Button */}
        <div className="flex-shrink-0">
          <button
            className={`px-8 py-3 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
              buttonLink ? "cursor-pointer" : "cursor-default"
            }`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
              fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
              fontStyle: explicitBoleanCheck(buttonIsItalic)
                ? "italic"
                : "normal",
              textDecoration: explicitBoleanCheck(buttonIsUnderline)
                ? "underline"
                : "none",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HorizontalTemplateOneOneEight;
